import dayjs from "dayjs";

export const sumDuration = (durations: (string | undefined | null)[]) => {
  const sum = durations.reduce((acc, duration) => {
    if (!duration) {
      return acc;
    }

    const timeArray = duration.split(":");
    return acc.add(
      dayjs.duration({ hours: +timeArray[0], minutes: +timeArray[1] }),
    );
  }, dayjs.duration(0));

  return `${Math.floor(sum.asHours())}:${sum.minutes()}`;
};

/**
 * Parses a duration string in the format "HH:MM" and returns an object with hours and minutes.
 * @param duration - The duration string to parse, expected in "HH:MM" format.
 * @returns An object containing the hours and minutes extracted from the duration string.
 * @example
 * // Example usage:
 * const duration = "02:30";
 * const parsed = parseDuration(duration);
 * console.log(parsed); // { hours: 2, minutes: 30 }
 */
export const parseDuration = (
  duration: string,
): { hours: number; minutes: number } => {
  const splittedValue = duration.split(":");

  return {
    hours: Number(splittedValue[0]?.trim()),
    minutes: Number(splittedValue[1]?.trim()),
  };
};
